var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCautioninline = function SvgCautioninline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.333 10A8.333 8.333 0 0 1 10 18.332a8.333 8.333 0 0 1-8.333-8.334c0-4.6 3.731-8.333 8.333-8.333a8.335 8.335 0 0 1 8.333 8.333ZM10 11.68a1.546 1.546 0 1 0 0 3.09 1.546 1.546 0 0 0 0-3.09Zm-1.218-.987-.25-4.57a.403.403 0 0 1 .403-.425h2.13c.231 0 .415.194.403.425l-.25 4.57a.403.403 0 0 1-.402.382H9.184a.403.403 0 0 1-.402-.382Z",
    fill: "#FFC507"
  })));
};
export default SvgCautioninline;